import React from 'react';

const ProjectsGrid = () => {
    const projects = [
        {
            id: 1,
            title: "BharatiyaBazaar",
            category: "E-Commerce",
            image: "img/projects/BharatiyaBazaar.png",
            description: "Full e-commerce platform for traditional Indian products with payment integration.",
            tags: ["E-Commerce", "UI/UX", "Payment Gateway"],
            link: "http://www.bharatiyabazaar.com"
        },
        {
            id: 2,
            title: "All About Foods",
            category: "Food & Resto",
            image: "img/projects/allaboutfood.jpg",
            description: "Restaurant & food discovery website with menu management and mobile-first design.",
            tags: ["Website", "SEO", "Responsive"],
            link: "http://www.allaboutfoods.in"
        },
        {
            id: 3,
            title: "MSPL",
            category: "Corporate",
            image: "img/projects/MSPL.jpg",
            description: "Corporate website for a manufacturing firm with professional design.",
            tags: ["Corporate", "Web Design", "Branding"],
            link: "https://mspl-v0-1.vercel.app/"
        },
        {
            id: 4,
            title: "PC Reviver",
            category: "Tech Services",
            image: "img/projects/PCreviver.jpg",
            description: "Tech repair service website with service listings and local SEO.",
            tags: ["Service Site", "Local SEO", "Booking"],
            link: "https://www.pcreviver.in"
        },
        {
            id: 5,
            title: "iGRABiT",
            category: "E-Commerce",
            image: "img/projects/Grabit.png",
            description: "Online product store with category management and cart system.",
            tags: ["E-Commerce", "Mobile-First", "UI/UX"],
            link: "http://www.igrabit.store"
        },
    ];

    return (
        <div className="row g-4">
            {projects.map((project) => (
                <div key={project.id} className="col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="proj-card">
                        <div className="proj-img">
                            <span className="proj-cat">{project.category}</span>
                            <img src={project.image} alt={project.title} />
                            <div className="proj-overlay">
                                <a href={project.link} target="_blank" rel="noreferrer">
                                    <i className="fa fa-external-link-alt"></i> Visit Site
                                </a>
                            </div>
                        </div>
                        <div className="proj-body">
                            <h4>{project.title}</h4>
                            <p>{project.description}</p>
                            <div className="tech-tags">
                                {project.tags.map((tag, idx) => (
                                    <span key={idx} className="tech-tag">{tag}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            
            {/* Your Project Next Card */}
            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                <div className="proj-placeholder">
                    <div className="ph-icon"><i className="fa fa-plus"></i></div>
                    <h5>Your Project Next?</h5>
                    <p>Let's build something amazing together.</p>
                    <a href="/contact" className="btn btn-primary rounded-pill px-4">Get Started</a>
                </div>
            </div>
        </div>
    );
};


export default ProjectsGrid;
